import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import so from './so.json';

/**
 * Admin portal i18n (slice 17).
 *
 * EN + SO from the first commit — Mahad's call, taken deliberately rather than
 * carving an exception into the standing rule ("English and Somali are both
 * first-class; every user-facing string goes through i18n from the first
 * commit"). The tempting argument was that an internal HQ tool is not really
 * user-facing; that would have been an agent narrowing a standing rule on its
 * own judgement.
 *
 * 🔴 `saveMissing` IS DELIBERATELY LEFT AT ITS DEFAULT (false), and there is no
 * throwing `missingKeyHandler` here. Slice 04 shipped exactly that and it was
 * DEAD CODE: i18next only calls the handler under `saveMissing`, so a guard
 * documented as catching missing translations never ran. The parity between
 * these two bundles is asserted by a test instead — something that actually
 * executes.
 */
void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, so: { translation: so } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
